import { get } from 'lodash';
import { isIEorEdge, base64ToBlob } from './IEHelper';
import { caseInsensitiveSort } from './FormHelper';
import { toastInfo } from './ToastHelper';
import { GENERIC_NO_DATA_FOUND } from './Constants';

const url = window.URL || window.webkitURL || window || {};

export const SiteObjectHelper = (sites, self) => {
  const sitesOptions = [];
  sites.map((site, i) => {
    if (
      (self && self === site.Id) ||
      (site.IsActive === true &&
        site.SiteMasterTypeId === 1 &&
        site.IsLicensed === true)
    ) {
      sitesOptions.push({
        value: site.Id,
        key: i,
        text: site.Id + ' ' + site.Description,
      });
    }
    return null;
  });

  return sitesOptions;
};

export const ReportGeneration = (report, fileName) => {
  const data = report.replace('data:application/pdf;base64,', '');
  const blob = base64ToBlob(data, 'application/pdf');
  const href = url.createObjectURL(blob, { type: 'application/pdf' });

  if (isIEorEdge) {
    window.navigator.msSaveOrOpenBlob(blob, `${fileName}.pdf`);
  } else {
    window.open(href, '_blank');
  }
  return;
};

/**
 * Functionalizes checking to see if the component has received the form and opens a new tab with the form
 * @param {Object} props - components current props
 * @param {Object} prevProps - component's previous props
 * @param {String} title - title for form
 * @param {String} key - accessor
 * @returns {Boolean} - returns true if form has been create
 */
export const GenerateReport = (
  props,
  prevProps,
  title,
  key = 'report',
  hasReportCb
) => {
  const report = get(props, key);
  const prevReport = get(prevProps, key);

  let hasReport = false;
  if (report !== null && report !== prevReport) {
    if (report === '') {
      toastInfo(GENERIC_NO_DATA_FOUND);
    } else {
      ReportGeneration(report, title);
    }
    hasReport = true;
  }

  if (hasReport && hasReportCb) {
    hasReportCb();
  }

  return hasReport;
};

export const DropdownObjectCreator = (
  DropdownObject,
  key1,
  key2,
  idRequired = false
) => {
  return caseInsensitiveSort(
    DropdownObject.map((ddProperty, i) => ({
      value: ddProperty[`${key1}`],
      key: ddProperty[`${key1}`],
      text: idRequired
        ? ddProperty[`${key1}`] + ' ' + ddProperty[`${key2}`]
        : ddProperty[`${key2}`],
    }))
  );
};



// WEBPACK FOOTER //
// ./src/common/ObjectHelper.js